<template>
	<Loading :loading="loading">
		<div v-if="memberDetails" class="col-12 col-md-8">
			<div class="row">
				<div class="col-12">
				<h2>My Details</h2>
				<p>Here is where you can edit your address, phone and email details.</p>
				<p>Please check that the details below are correct and up-to-date. Edit any that need changing by overtyping the text. Please make sure that you click the 'Save Details' button at the bottom to save your changes.</p>
				<p v-if="$store.state.auth.memberLevel != 'silver'">Need to renew your membership? <router-link :to="{name:'accountMembershipRenewal'}">Please click here.</router-link></p>
				</div>
			</div>

			<div class="accountDetails row" v-if="accountDetails">
				<h3 class="col-12">Member Details:</h3>

				<div class="label col-12 col-sm-5">Membership Number:</div>
				<!-- This is a bit of a hack, but prepend the first letter of the member level to the account id -->
				<!-- Means that silver member is S1234 and gold is G1234 -->
				<div class="col-12 col-sm-7">{{$store.state.auth.memberLevel[0].toUpperCase()}}{{accountDetails.account_id}}</div>

				<div class="label col-12 col-sm-5">Membership Name:</div>
				<div class="col-12 col-sm-7"> {{accountDetails.account_name}}</div>

				<div v-if="new Date(accountDetails.account_expiration_date) > 0" class="label col-12 col-sm-5">Membership Expires:</div>
				<div v-if="new Date(accountDetails.account_expiration_date) > 0" class="col-12 col-sm-7"> {{new Date(accountDetails.account_expiration_date).toLocaleDateString('en-NZ', { year: 'numeric', month: 'long', day: 'numeric' })}}</div>

				<div class="label col-12 col-sm-5">Membership Type:</div>
				<div class="col-12 col-sm-7 capitalize">{{$store.state.auth.memberLevel}}</div>

				<div class="label col-12 col-sm-5">Others on this Membership:</div>
				<div class="col-12 col-sm-7">{{accountDetails.other_members}}</div>

				<div class="label col-12 col-sm-5">Date Joined:</div>
				<div class="col-12 col-sm-7">{{new Date(memberDetails.date_joined).toLocaleDateString('en-NZ', { year: 'numeric', month: 'long', day: 'numeric' })}}</div>
			</div>
			<br>

			<h3>Personal Details:</h3>
			<form v-on:submit.prevent="onSubmit" data-vv-scope="memberDetails">
				<div class="form-group row">
					<label class="col-sm-5 col-form-label">Given Name*</label>
					<input
						type="text"
						v-model="memberDetails.given_name"
						class="col-sm-7 form-control"
						v-validate="'required'"
						data-vv-name="Given Name"
					>
					<div class="invalid-feedback">{{errors.first('memberDetails.Given Name')}}</div>

					<label class="col-sm-5 col-form-label">Family Name*</label>
					<input
						type="text"
						v-model="memberDetails.family_name"
						class="col-sm-7 form-control"
						v-validate="'required'"
						data-vv-name="Family Name"
					>
					<div class="invalid-feedback">{{errors.first('memberDetails.Family Name')}}</div>

					<label class="col-sm-5 col-form-label">Email*</label>
					<input
						type="text"
						v-model="memberDetails.email"
						class="col-sm-7 form-control"
						name="email"
						v-validate="'email|required'"
						data-vv-as="email"
					>
					<div class="invalid-feedback">{{errors.first('memberDetails.email')}}</div>

					<label class="col-sm-5 col-form-label">Home Phone</label>
					<input
						type="text"
						v-model="memberDetails.home_phone"
						class="col-sm-7 form-control"
						name="homephone"
						v-validate="{regex:/^([+]?[0-9 ]+)$/}"
						data-vv-as="Home Phone"
					>
					<div class="invalid-feedback">{{errors.first('memberDetails.phone')}}</div>

					<label class="col-sm-5 col-form-label">Cell Phone</label>
					<input
						type="text"
						v-model="memberDetails.cellphone"
						class="col-sm-7 form-control"
						name="cellphone"
						v-validate="{regex:/^([+]?[0-9 ]+)$/}"
						data-vv-as="Cell Phone"
					>
					<div class="invalid-feedback">{{errors.first('memberDetails.cellphone')}}</div>
				</div>
				<!-- <div class="form-group row">
				<h3 class="col-12">Newsletter:</h3>
				<div class="col-5"></div>
				<div class="col-7">
					<label class="form-check-label">
					<input
						type="checkbox"
						v-model="memberDetails.send_newsletter"
						class="form-check-input"
					>
					Recieve Newsletter
					</label>
				</div>
				</div> -->
				<div class="form-group row">
					<h3 class="col-12">Delivery Details:</h3>
					<label class="col-sm-5">Street*</label>
					<input
						type="text"
						v-model="memberDetails.delivery_street_address"
						name="Delivery Street Address"
						class="col-sm-7 form-control"
						v-validate="'required'"
					>
					<div class="invalid-feedback">{{errors.first('memberDetails.Delivery Street Address')}}</div>

					<label class="col-sm-5">Suburb</label>
					<input type="text" v-model="memberDetails.delivery_suburb" class="col-sm-7 form-control" name="Delivery Suburb">
					<div class="invalid-feedback">{{errors.first('memberDetails.Delivery Suburb')}}</div>

					<label class="col-sm-5">City*</label>
					<input type="text" v-model="memberDetails.delivery_city" class="col-sm-7 form-control" v-validate="'required'" name="Delivery City">
					<div class="invalid-feedback">{{errors.first('memberDetails.Delivery City')}}</div>

					<label class="col-sm-5">Post Code*</label>
					<input
						type="text"
						v-model="memberDetails.delivery_postcode"
						v-validate="{required:true, regex: /^\d{4}$/}"
						name="Delivery Postcode"
						class="col-sm-7 form-control"
					>

					<div class="invalid-feedback">{{errors.first('memberDetails.Delivery Postcode')}}</div>

					<label class="col-sm-5 col-form-label">Preferred Contact Number</label>
					<input
						type="text"
						v-model="memberDetails.prefered_contact_number"
						class="col-sm-7 form-control"
						name="preferred_contact_number"
						v-validate="{regex:/^([+]?[0-9 ]+)$/}"
						data-vv-as="Preferred Contact Number"
					>
					<div class="invalid-feedback">{{errors.first('memberDetails.preferred_contact_number')}}</div>

					<label class="col-sm-5">Delivery Instructions</label>
					<textarea
						rows="3"
						v-model="memberDetails.delivery_instructions"
						class="col-sm-7 form-control"
					/>

					<div class="form-check-inline col-12">
						<div class="col-0 col-md-5"></div>
						<div class="col-md-7 col-12">
						<label class="form-check-label">
							<input type="checkbox" v-model="billingSameAsDelivery" class="form-check-input">
							Billing & delivery address same
						</label>
						</div>
					</div>
				</div>
				<div v-if="billingSameAsDelivery === false" class="form-group row">
					<h3 class="col-12">Billing Details:</h3>

					<label class="col-sm-5">Street*</label>
					<input
						type="text"
						v-model="memberDetails.billing_street_address"
						class="col-sm-7 form-control"
						v-validate="'required'"
						name="Billing Street Address"
					>
					<div class="invalid-feedback">{{errors.first('memberDetails.Billing Street Address')}}</div>


					<label class="col-sm-5">Suburb</label>
					<input type="text" v-model="memberDetails.billing_suburb" class="col-sm-7 form-control" name="Billing Suburb">
					<div class="invalid-feedback">{{errors.first('memberDetails.Billing Suburb')}}</div>



					<label class="col-sm-5">City*</label>
					<input type="text" v-model="memberDetails.billing_city" class="col-sm-7 form-control" v-validate="'required'" name="Billing City">

					<div class="invalid-feedback">{{errors.first('memberDetails.Billing City')}}</div>

					<label class="col-sm-5">Post Code*</label>
					<input type="text" v-model="memberDetails.billing_postcode" class="col-sm-7 form-control" v-validate="{required:true, regex: /^\d{4}$/}" name="Billing Postcode">
					<div class="invalid-feedback">{{errors.first('memberDetails.Billing Postcode')}}</div>

				</div>
				<div class="row justify-content-center">
					<ButtonWithLoading
						type="submit"
						class="btn btn-primary"
						text="Save Details"
						loadingText="Saving Details"
						successText="Updated Details"
						failureText="Error updating Details"
						:state="detailsSubmitState"
					/>
				</div>
				<span>* = Required</span>
				<div v-if="message" class="row justify-content-center">
					<div class="alert alert-danger col-auto">
					{{message}}
					</div>
				</div>
			</form>
		</div>
	</Loading>
</template>

<script>

import { fetchUserDetails, saveUserDetails } from "@/network/userRequests";
import Loading from "@/components/loading/Loading";
import ButtonWithLoading from "@/components/buttonWithLoading";

export default {
	name: "MyAccount",
	data: () => {
		return {
			user: null,
			saving: false,
			message: "",
			detailsSubmitState: null,
			billingSameAsDelivery: null,
			loading: false,
		};
	},
	components: {
		ButtonWithLoading,
		Loading
	},
	created() {
		this.getData();
	},
	computed: {
		accountDetails() {
			if (this.user && this.user.account_details) {
				return this.user.account_details;
			}
			return null;
		},
		memberDetails() {
			if (this.user && this.user.member_details) {
				let details = this.user.member_details
				if (details.home_phone==null || details.home_phone==undefined){
					details.home_phone=''
				}
				if (details.cellphone==null || details.cellphone==undefined){
					details.cellphone=''
				}
				if (details.preferred_contact_number==null || details.preferred_contact_number==undefined){
					details.preferred_contact_number=''
				}
				return details;
			}
			return null;
		},
	},
	methods: {
		getData() {
			this.loading = true;
			fetchUserDetails(userDetails => {
				this.user = userDetails;
				this.loading = false;
				//check if billing and delivery address are the same
				this.billingSameAsDelivery = this.addressesMatch(userDetails);
			});
		},
		addressesMatch() {
			const {
				delivery_street_address,
				delivery_city,
				delivery_postcode,
				delivery_suburb,
				billing_street_address,
				billing_city,
				billing_postcode,
				billing_suburb
			} = this.user.member_details;

			return (
				delivery_street_address === billing_street_address &&
				delivery_suburb === billing_suburb &&
				delivery_city === billing_city &&
				delivery_postcode === billing_postcode
			);
		},
		setBillingAddressToDelivery() {
			var {
				delivery_street_address,
				delivery_city,
				delivery_postcode,
				delivery_suburb
			} = this.user.member_details;

			this.user.member_details.billing_street_address = delivery_street_address;
			this.user.member_details.billing_suburb = delivery_suburb;
			this.user.member_details.billing_city = delivery_city;
			this.user.member_details.billing_postcode = delivery_postcode;
		},
		onSubmit() {
			this.$validator.validateAll("memberDetails").then(valid => {
				if (!valid) return;
				this.detailsSubmitState = "loading";
				//set billing same as delivery before backend request if box ticked
				if (this.billingSameAsDelivery) this.setBillingAddressToDelivery();
				saveUserDetails(
					{ memberDetails: this.user.member_details },
					(response) => {
						if(response.success){
							//success saving user details
							this.detailsSubmitState = "success";
							this.errors.clear();
							this.$validator.reset();
							this.message = null
							setTimeout(() => {
								this.detailsSubmitState = null;
							}, 1000);
						}else{
							this.detailsSubmitState = "failure";
							this.message = response.error;
							this.errors.clear();
							this.$validator.reset();
							setTimeout(() => {
								this.detailsSubmitState = null;
							}, 1000);
						}
					},
					() => {
						//failure saving user details
						this.detailsSubmitState = "failure";
						this.message = "Error saving form";
						setTimeout(() => {
							this.detailsSubmitState = null;
						}, 1000);
					}
				);
			});
		},
	}
};
</script>

<style lang="scss" scoped>
</style>
